import { helpers, required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import gButton from "@/components/g-button/g-button";
import Tools from "@/shared/services/tools"
import ComponenteViewModel from "@/shared/view-models/ComponenteViewModel";
import ProdutoController from "@/shared/controllers/produto/produtoController"
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import { defineComponent } from "vue";
import UnidadeController from "@/shared/controllers/unidade/unidadeController";
//import ComponenteViewModel from "@/shared/view-models/ComponenteViewModel";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ComponenteController from "@/shared/controllers/componente/componenteController";

const name = 'CompProdutoRA'
export default defineComponent({
  name,

  components: {
    'g-button' :gButton
   },

  props: { },

  mounted () {
    OrcamentoController.VerificaSeOrcamentoTemQuantidade(this.$route.params.id).requisicao
    .then((response) => {
      if(response.data.data == false){
        this.$toast.add({severity:'error', detail:'Erro ao Salvar Quantidade. Por favor tente novamente.', life: 5000})
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/info-basicas-ra`)
      }
    })
    EmpresaController.getAllEmpresa().requisicao
    .then((Response) => {
      this.UnidadeArrayComponenteTipo = Response.data.data
      this.UnidadeArray = Response.data.data
    })
    this.popularDropDownComponente()
    this.popularAcabamentoFrente()
    this.popularDescricaoMaterial()
    this.popularDescricaoSistema()
    this.popularMedidaConforme()
    this.popularCorFrente()
    this.popularCorVerso()
    this.popularAcabamentoVerso()
    this.popularCapaInterna()
    this.popularCapaExterna()
    this.popularMaterial()
    this.popularPapelOnda()
    this.OndaArray= ComponenteController.getEnumDescricaoOnda().OndaArray
    this.popularSistema()

    this.getClienteId()
    this.getProdutoIdByOrcamentoId()
    this.getOrcamentobyId()
    this.ImagemEmpresa()
    this.ProdutoSistemaOpcoes  = ProdutoController.GetProdutoByTableSistema().ProdutoOpcoesProdutoNumero

  


    // this.getUnidade()


  },

  setup(){
    return {
      v$: useVuelidate()
    }
  },

  updated () { },

  data () {
    return {
      popupCancelaOrc: false,
      imagemEmpresa: '',
      ProdutoOpcoesProdutoNumero: [],
      EhAdicionavel: true,
      ehAmostraEspecificacaoTecnica: false,
      ehEdicao:true,
      temAmostra: false,
      popupadicionarreferencia: '',
      novoComponente: new ComponenteViewModel(),
      indexAux: -1,


      // -- DropDowns --
      TipoComponenteSelecionado:{ "text": "...", "value": null, "enum": null },
      TipoComponenteArray:[],

      MedidaConformeSelecionada:{ "text":"...", "value": null, "enum": null },
      MedidaConformeArray:[],

      CorFrenteSelecionada:{ "text":"...", "value": null, "enum": null },
      CorFrenteArray:[],

      CorVersoSelecionada:{ "text": "...", "value": null, "enum": null },
      CorVersoArray:[],

      CorFrenteAcabamentoSelecionada:{ "text": "...", "value": null, "enum": null },
      CorFrenteAcabamentoArray:[],

      CorVersoAcabamentoSelecionada:{ "text":"...", "value": null, "enum": null },
      CorVersoAcabamentoArray:[],

      CapaInternaSelecionada:{ "text": "...", "value": null, "enum": null },
      CapaInternaArray:[],

      CapaExternaSelecionada:{ "text":"...", "value": null, "enum": null },
      CapaExternaArray:[],

      MaterialSelecionado:{ "text": "...", "value": null, "enum": null },
      MaterialArray:[],

      PapelOndaSelecionado:{ "text": "...", "value": null, "enum": null },
      PapelOndaArray:[],

      OndaSelecionada:{ "text": null, "value": null, "enum": null },
      OndaArray:[],

      SistemaSelecionado:{ "text": null, "value": null, "enum": null },
      SistemaArray:[],

      UnidadeSelecionada:{ "id": null, "nome": null},
      UnidadeArray:[],

      //-- end DropDowns --
      altura: null,
      UnidadeArrayComponenteTipo: null,
      numeroPrototipoComponenteTipo: null,
      comprimento:null,
      EmpresaId:null,
      produtoId: null,
      largura:null,
      alturaTampa:null,
      gramaturaCapaInterna:null,
      gramaturaCapaExterna:null,
      gramaturaPapelOnda:null,
      codigo:null,
      produto:null,
      OrcamentoComponenteId:null,
      ProdutoArray:[],
      reorcamento: false,
      copiaOrcamentoQuantidade: false,
      ProdutoOpcoes: [],
      ProdutoMaterialId: '',
      UnidadeSelecionadaComponenteTipo: '',
      ConformeTabelaSistemaOpcoes: [],
      SistemaId: '',
      UnidadeSelecionadaSistema: '',
      ProdutoSistemaId: '',
      numeroPrototipoSistema: 0,


      popupadicionarcomponente: false,
      Colunas : [
        //Campo dos dados , nome que aparece na página
        {field: "NumeroComponente", header: "Número"},
        {field: 'ComponenteTipoTexto', header: 'Componente'},
        {field: 'ColunaMedidas', header: 'Medidas'},
        {field: 'DescricaoCoresFrenteTexto', header: 'Cor Frente'},
        {field: 'DescricaoCoresVersoTexto', header: 'Cor Verso'},
        {field: 'DescricaoAcabamentoFrenteTexto', header: 'Acabamento Frente'},
        {field: 'DescricaoAcabamentoVersoTexto', header: 'Acabamento Verso'},
        {field: 'DescricaoMaterialTexto', header: 'Material'},
        {field: 'DescricaoCapaExternaTexto', header: 'Capa Externa'},
        {field: 'NumeroGramaturaCapaExterna', header: 'Gramatura'},
        {field: 'DescricaoPapelOndaTexto', header: 'Papel Onda'},
        {field: 'NumeroGramaturaPapelOnda', header: 'Gramatura'},
        {field: 'DescricaoCapaInternaTexto', header: 'Capa Interna'},
        {field: 'NumeroGramaturaCapaInterna', header: 'Gramatura'},
        {field: 'DescricaoOndaTexto', header: 'Onda'},
        {field: 'SistemaTexto', header: 'Sistema', width: '9%'},


      ], //colunas da tabela
      key: 0,
      informacao: [],
      empresaIdSelecionado: '',
      ProdutoSistemaOpcoes: []
    }
  },

  validations() {
    return{
      numeroPrototipoComponenteTipo: {required: helpers.withMessage('O campo de N° Protótipo do Conforme necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == 1))},
      numeroPrototipoMaterial: {required: helpers.withMessage('O campo de N° Protótipo do Material necessita de um valor', requiredIf(this.novoComponente.DescricaoMaterial == 7))},
      numeroPrototipoSistema: {required: helpers.withMessage('O campo de N° Protótipo do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 3 ))},
      UnidadeSelecionadaComponenteTipo :{required: helpers.withMessage('O campo de Unidade do Conforme necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == 0 ))},
      ProdutoMaterialId : {required: helpers.withMessage('O campo de Produto do Conforme necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == 0 ))},
      SistemaSelecionado        : {required: helpers.withMessage('O campo de Sistema necessita de um valor', required)},
      UnidadeSelecionadaSistema :{required: helpers.withMessage('O campo de Unidade do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 2))},
      ProdutoSistemaId : {required: helpers.withMessage('O campo de Produto do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 2 && !(this.ProdutoSistemaId)))},
      SistemaId : {required: helpers.withMessage('O campo de Produto do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 0  && (this.SistemaId == null || this.SistemaId == undefined) ))},

      novoComponente:{
          ComponenteTipo            : {required: helpers.withMessage('O campo de Tipo Componente necessita de um valor', required)},
          DescricaoMaterial         : {required: helpers.withMessage('O campo de Material necessita de um valor', required)},
          DescricaoPapelOnda        : {required: helpers.withMessage('O campo de Papel Onda necessita de um valor', requiredIf(!this.ObrigatoriedadePapelDeOndaComp))},
          NumeroGramaturaPapelOnda  : {required: helpers.withMessage('O campo de Número Gramatura Papel Onda necessita de um valor', requiredIf(!this.ObrigatoriedadePapelDeOndaComp))},
          NumeroGramaturaCapaExterna: {required: helpers.withMessage('O campo de Número Gramatura Capa Externa necessita de um valor', requiredIf(!this.ObrigatoriedadeGramaturaCapaExternaComp))},
          DescricaoCapaExterna      : {required: helpers.withMessage('O campo de Capa Externa necessita de um valor', requiredIf(!this.ObrigatoriedadeDescricaoCapaExternaComp))},
          NumeroAlturaTampa         : {required: helpers.withMessage('O campo de Altura Tampa necessita de um valor', requiredIf(!this.ObrigatoriedadeAlturaTampaComp && this.novoComponente.DescricaoMedidas == null))},
          DescricaoMedidas          : {required: helpers.withMessage('O campo de Conforme necessita de um valor', requiredIf( this.novoComponente.NumeroAltura == null && this.novoComponente.NumeroComprimento == null && this.novoComponente.NumeroLargura == null ))},
          DescricaoCoresVerso       : {required: helpers.withMessage('O campo de Cor Verso de um valor', required)},
          DescricaoCoresFrente      : {required: helpers.withMessage('O campo de Cor Frente de um valor', required)},
          DescricaoAcabamentoVerso  : {required: helpers.withMessage('O campo de Acabamento Verso necessita de um valor', required)},
          DescricaoAcabamentoFrente : {required: helpers.withMessage('O campo de Acabamento Frente necessita de um valor', required)},
          DescricaoCapaInterna      : {required: helpers.withMessage('O campo de Capa Interna de um valor', requiredIf(!this.ObrigatoriedadeCapaInternaComp))},
          NumeroGramaturaCapaInterna: {required: helpers.withMessage('O campo de Número Gramatura Capa Interna necessita de um valor', requiredIf(!this.ObrigatoriedadeCapaInternaComp))},
          NumeroAltura              : {required: helpers.withMessage('O campo de Altura necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == null))},
          NumeroComprimento         : {required: helpers.withMessage('O campo de Comprimento necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == null))},
          NumeroLargura             : {required: helpers.withMessage('O campo de Largura necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == null))},

      }
    }
   },

  methods: {
    GetUnidadeByProdutoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetUnidadeByProdutoId/${this.produtoIdSelecionado}`,
      }).then((res) => {
        // this.getComponetesByOrcamentoId()
        this.UnidadeSelecionadaSistema = res.data.data;

      })
    },
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-alteracao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    VerificacaoSistema(){
      // this.ProdutoSistemaOpcoes = []
      this.SistemaId = null;
      this.ProdutoSistemaId = null;
      this.UnidadeSelecionadaSistema = null;
      this.numeroPrototipoSistema = null;


      if(this.SistemaSelecionado != null && this.novoComponente.ComponenteTipo == null)
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Selecione um componente', life: 7000 });
        this.SistemaSelecionado = null
      }

      if(this.SistemaSelecionado == 1 && this.temAmostra == false )
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Para sistema Conforme Amostra, é necessário marcar o item Acompanha amostra na tela anterior!', life: 7000 });
        this.SistemaSelecionado = null
      }
      // this.SistemaSelecionado == 2 ? this.campConformeProdutoSistema = true : this.campConformeProdutoSistema = false
      // this.SistemaSelecionado == 3 ? this.campPrototipoSistema = true : this.campPrototipoSistema = false
      this.SistemaSelecionado == 0 ? this.campConformeTabelaSistema = true : this.campConformeTabelaSistema = false


      if(this.SistemaSelecionado ==0)
      {
        this.getUnidadeByClienteId()
        this.limpaCamposSistema()
      }
      else if(this.SistemaSelecionado == 2 )
      {
        EmpresaController.getAllEmpresa().requisicao
          .then((Response) => {
            this.UnidadeArray = Response.data.data
          }) 
         this.limpaCamposSistema()
      } else if (this.SistemaSelecionado != 2 && this.SistemaSelecionado != 0) {
        this.limpaCamposSistema()
      }
    },

    buscarProdutosConformeProduto(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.getProdutoDropDown(this.$route.params.id, true, false, true, pesquisa, this.UnidadeSelecionadaComponenteTipo).ProdutoArray;
      }, 1000);
    },

    buscarProdutosProdutoNumero(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoesProdutoNumero = ProdutoController.getProdutoDropDown(this.$route.params.id, true, true, true, pesquisa, this.UnidadeSelecionadaSistema).ProdutoArray;
      }, 1000);
    },

    buscarProdutosSistema(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.getProdutoDropDown(this.$route.params.id, true, true, true, pesquisa, this.UnidadeSelecionadaSistema).ProdutoArray;
      }, 1000);
    },

    procurarSistema(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ConformeTabelaSistemaOpcoes = ProdutoController.GetSistemaByFiltro(this.novoComponente.ComponenteTipo, event).SistemaArray
      }, 1000);
    },

    verificaComponenteTipo(){

      !this.novoComponente.ComponenteTipo == 0 || !this.novoComponente.ComponenteTipo == 3 || !this.novoComponente.ComponenteTipo == 4 || !this.novoComponente.ComponenteTipo == 5 ? this.ObrigatoriedadeAlturaTampa = true : this.ObrigatoriedadeAlturaTampa=false
        if(this.novoComponente.ComponenteTipo != 0)
        {
          if(this.novoComponente.DescricaoMedidas == 5)
          {
            this.novoComponente.DescricaoMedidas = null
          }
        }
        else if(this.novoComponente.ComponenteTipo == null)
        {
          this.SistemaSelecionado == null
        }
        else if(this.novoComponente.ComponenteTipo == 0 || this.novoComponente.ComponenteTipo == 3 || this.novoComponente.ComponenteTipo == 4 || this.novoComponente.ComponenteTipo == 5)
        {
          this.novoComponente.NumeroAlturaTampa = null
        }

    },

    limparConforme(){
      if(this.novoComponente.NumeroLargura != null || this.novoComponente.NumeroAltura != null || this.novoComponente.NumeroComprimento != null || this.novoComponente.NumeroAlturaTampa != null)
      this.novoComponente.DescricaoMedidas = null
    },

    procurarProdutoOpcoes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.GetProdutoByUsuarioIdEmpresaId(event, this.$route.params.id, this.UnidadeSelecionadaSistema).ProdutoArray
      }, 1000);
    },
    procurarProdutoOpcoesMaterial(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.GetProdutoByUsuarioIdEmpresaId(event, this.$route.params.id, this.UnidadeSelecionadaComponenteTipo).ProdutoArray
      }, 1000);
    },

    limparProdutoMaterial(){
      this.ProdutoMaterialId = ''
      this.ProdutoOpcoes = []
    },

    limparProdutoSistema(){
      this.ProdutoSistemaId = ''
      this.ProdutoOpcoesProdutoNumero  = []
      this.ProdutoSistemaOpcoes = []
    },

    desativarCamposMateriais(){

      this.novoComponente.DescricaoOnda=undefined
      this.novoComponente.DescricaoCapaExterna=undefined
      this.novoComponente.NumeroGramaturaCapaExterna=undefined
      this.novoComponente.DescricaoPapelOnda = undefined
      this.novoComponente.NumeroGramaturaPapelOnda = undefined
      this.novoComponente.DescricaoCapaInterna=undefined
      this.novoComponente.NumeroGramaturaCapaInterna = undefined
      this.numeroPrototipoMaterial = null

      this.ObrigatoriedadeExterna = !this.novoComponente.DescricaoMaterial == 2 || !this.novoComponente.DescricaoMaterial == 4 || !this.novoComponente.DescricaoMaterial == 5 || !this.novoComponente.DescricaoMaterial == 6 || !this.novoComponente.DescricaoMaterial == 7 || !this.novoComponente.DescricaoMaterial == 8

      if(this.novoComponente.DescricaoMaterial == 8){
        this.novoComponente.DescricaoCapaExterna =  9
      }

      else if(this.novoComponente.DescricaoMaterial == 4 && this.temAmostra == false )
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Para material Conforme Amostra, é necessário marcar o item Acompanha amostra na tela anterior!', life: 7000 });
        this.novoComponente.DescricaoMaterial = null
      }

    },

    limparCamposMedidas(){
      this.altura=0,
      this.alturaTampa=0,
      this.comprimento=0,
      this.largura=0

      this.novoComponente.NumeroAltura = null
      this.novoComponente.NumeroComprimento = null
      this.novoComponente.NumeroLargura = null
      this.novoComponente.NumeroAlturaTampa = null


      if (this.novoComponente.DescricaoMedidas == 5)
      {
        if(this.novoComponente.ComponenteTipo != 0)
        {
          this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Item Conforme fundo exclusivo para o componente Tampa', life: 4000 });
          this.novoComponente.DescricaoMedidas = null
        }
      }
      else if(this.novoComponente.DescricaoMedidas == 0)
      {
        EmpresaController.getAllEmpresa().requisicao
        .then((Response) => {
          this.UnidadeArrayComponenteTipo = Response.data.data
        })
      }
      else if(this.novoComponente.DescricaoMedidas == 4 && this.temAmostra == false )
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Para medida Conforme Amostra, é necessário marcar o item Acompanha amostra na tela anterior!', life: 7000 });
        this.novoComponente.DescricaoMedidas = null
      }


    },
    getProdutoIdByOrcamentoId(){

      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API +`Produto/GetProdutoByOrcamentoId/${this.$route.params.id}`,
      })
        .then((Response) => {
          this.ProdutoId=Response.data.data
          this.getComponetesByOrcamentoId()

        })
        .catch(() => {
        });
    },
    getClienteId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/GetClienteByOrcamento/${this.$route.params.id}`,
      })
        .then((response) => {
          this.ClienteId=response.data.data.id
          // this.getUnidade()

        })
        .catch(() => {
        });
    },

    getOrcamentobyId(){
      let OrcamentoId = this.$route.params.id
      let retorno = this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoById/Get/${OrcamentoId}`,
     })
     .then((response) => {
      this.reorcamento = response.data.data.reorcamento;
      this.copiaOrcamentoQuantidade = response.data.data.copiaOrcamentoQuantidade;
      this.ehAmostraEspecificacaoTecnica = response.data.data.amostraEspecificacaoTecnica;
      this.temAmostra = response.data.data.amostra;
      })
      return retorno
    },
    getComponetesByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API +`Componente/GetComponentesByOrcamentoId/${this.$route.params.id}`,
      })
        .then((Response) => {
        if(Response.data.data.length === 0)
        {
          this.GetComponentesByProdutoId()
          return;
        }
          Response.data.data.forEach(e  => {
            e = this.trocarChaveObjetoParaMaiusculo(e)
            this.informacao.push(e)
          })
          this.informacao = Response.data.data
          this.empresaIdSelecionado = Response.data.data[0].empresaId;

          this.informacao.forEach((r)=>{
            if(!r.NumeroComprimento && !r.NumeroLargura && !r.NumeroAltura && !r.NumeroAlturaTampa)
              r.ColunaMedidas = r.DescricaoMedidasTexto;
            else
              r.ColunaMedidas = `${r.NumeroComprimento} x ${r.NumeroLargura} x ${r.NumeroAltura} x ${r.NumeroAlturaTampa}`
            // r.CodigoSistema = 'Escolha conforme tabela'
          })
        })
        .catch(() => {
        });
    },

    trocarChaveObjetoParaMaiusculo(obj){
      Object.keys(obj).forEach(chave => {
        let chaveNova = ()=>{
          return `${chave[0].toUpperCase() + chave.slice(1,chave.length)}`
        }
        obj[chaveNova()] = obj[chave]
        delete obj[chave]
       })
       return obj
    },
    step6 () {
        this.postOrcamentoComponente()
    },
    voltarstep3 () {
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/info-basicas-ra`)
    },


    editar(data, i){
      this.indexAux = i 
      let dataConvertido = Tools.captalizeKeys(data);
      Tools.objectCustomAssign(this.novoComponente, dataConvertido);
      this.produtoIdSelecionado = data.ProdutoId
      this.SistemaSelecionado = data.DescricaoSistema
      this.ProdutoSistemaId = data.ProdutoSistemaId
      this.ProdutoMaterialId = data.ProdutoMaterialId
      this.numeroPrototipoSistema = data.NumeroPrototipoSistema
      this.numeroPrototipoMaterial = data.NumeroPrototipoMaterial
      this.numeroPrototipoComponenteTipo = data.NumeroPrototipoComponenteTipo
      this.SistemaId = data.SistemaId

      this.UnidadeSelecionadaSistema = this.novoComponente.SistemaUnidadeId;
      this.UnidadeSelecionadaComponenteTipo = this.novoComponente.ConformeUnidadeId;

      if(this.novoComponente.ProdutoMaterialLista){
        this.ProdutoOpcoes = this.novoComponente.ProdutoMaterialLista;
      }
      if(this.SistemaSelecionado == 0 && this.SistemaId==null)
      this.getUnidadeByClienteId()

      
      if(this.SistemaSelecionado == 0 && this.SistemaId!=null)
      this.GetUnidadeByProdutoId()

      if(this.novoComponente.ProdutoSitemaLista){
        this.ProdutoOpcoesProdutoNumero = this.novoComponente.ProdutoSitemaLista;
      }

      this.popupadicionarcomponente = true
    },

    adicionandocomponente(){ //adicionará na tabela o componente

      if(this.v$.$invalid){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })}else{

        this.popupadicionarcomponente=false
        this.EditarOrcamentoComponenteNoGrid()
        }


    },


    EditarOrcamentoComponenteNoGrid(){
      this.novoComponente.DescricaoSistema = this.SistemaSelecionado;
      this.novoComponente.ProdutoSistemaId = this.ProdutoSistemaId;
      this.novoComponente.ProdutoMaterialId = this.ProdutoMaterialId;
      this.novoComponente.NumeroPrototipoSistema = this.numeroPrototipoSistema;
      this.novoComponente.NumeroPrototipoMaterial = this.numeroPrototipoMaterial;
      this.novoComponente.SistemaUnidadeId = this.UnidadeSelecionadaSistema;
      this.novoComponente.ConformeUnidadeId = this.UnidadeSelecionadaComponenteTipo;
      this.novoComponente.NumeroPrototipoComponenteTipo = this.numeroPrototipoComponenteTipo;
      this.novoComponente.SistemaId = this.SistemaId;
      this.novoComponente.SistemaTexto = this.SistemaArray.filter(e => e.value === this.SistemaSelecionado)[0].text;

      this.informacao = this.informacao.map(obj => {
        if(obj.OrcamentoComponenteId === this.novoComponente.OrcamentoComponenteId){
          obj = this.novoComponente
        }
        return obj
      })
      this.novoComponente = new ComponenteViewModel();
    },


    populandodropdownproduto(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Produto/Get',
      }).then(Response => {
        this.ProdutoArray = Response.data.data
      })
      .catch(() => {
      });
    },
    popularDropDownComponente(){
      //getTipoComponente
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumTipoComponente',
      })
        .then((response) => {
          this.TipoComponenteArray = response.data
        })
        .catch(() => {
        });
    },
    procurarproduto(){
      this.populandodropdownproduto()
    },
    popularDescricaoMaterial(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/GetEnumDescricaoMaterial',

      }).then(Response => {
        this.MaterialArray=Response.data
      })
      .catch(() => {
      });
    },
    popularDescricaoSistema(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/GetEnumDescricaoSistema',

      }).then(Response => {
        this.SistemaArray=Response.data

      })
      .catch(() => {
      });
    },
    popularMedidaConforme(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/GetEnumDescricaoMedida',

      }).then(Response => {
        this.MedidaConformeArray=Response.data
      })
      .catch(() => {
      });
    },
    popularCorFrente(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoCoresFrente',

      }).then(Response => {
        this.CorFrenteArray=Response.data
      })
      .catch(() => {
      });
    },
    popularCorVerso(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoCoresVerso',

      }).then(Response => {
        this.CorVersoArray=Response.data
      })
      .catch(() => {
      });
    },
    popularAcabamentoFrente(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoAcabamentoFrente',

      }).then(Response => {
        this.CorFrenteAcabamentoArray=Response.data
      })
      .catch(() => {
      });
    },
    popularAcabamentoVerso(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoAcabamentoVerso',

      }).then(Response => {
        this.CorVersoAcabamentoArray=Response.data
      })
      .catch(() => {
      });
    },
    popularCapaInterna(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoCapaInterna',

      }).then(Response => {
        this.CapaInternaArray=Response.data
      })
      .catch(() => {
      });
    },
    popularCapaExterna(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoCapaExterna',

      }).then(Response => {
        this.CapaExternaArray=Response.data
      })
      .catch(() => {
      });
    },
    popularMaterial(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoMaterial',

      }).then(Response => {
        this.MaterialArray=Response.data
      })
      .catch(() => {
      });
    },
    popularPapelOnda(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoCapaPapelOnda',

      }).then(Response => {
        this.PapelOndaArray=Response.data
      })
      .catch(() => {
      });
    },
    popularOnda(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Componente/GetEnumDescricaoCapaPapelOnda',

      }).then(Response => {
        this.OndaArray=Response.data
      })
      .catch(() => {
      });
    },
    popularSistema(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/GetEnumDescricaoSistema',

      }).then(Response => {
        this.SistemaArray=Response.data
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },
    getUnidade(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API +`Cliente/GetUnidadeByClienteId/${this.ClienteId}`,
      })
        .then((Response) => {
          this.UnidadeArray = Response.data.data
          // this.UnidadeSelecionada.id=Response.data.data[0].id

        })
        .catch(() => {
        });
    },

    getUnidadeByClienteId(){
      UnidadeController.getUnicaUnidadeByClienteId(this.ClienteId).requisicao
        .then((Response) => {
          this.UnidadeSelecionadaSistema = Response.data.data


          EmpresaController.getAllEmpresa().requisicao
          .then((Response) => {
            this.UnidadeArray = Response.data.data
          })
        })
    },

    postOrcamentoComponente(){
      // this.informacao = Tools.formatarDados(this.informacao , null)
      this.$refs.botaoContinuar.isBusy()

      this.axios({
        method: 'post',
          url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/post',
          data:{
            //ProdutoId: this.informacao[0].produtoId,
            EmpresaId: this.empresaIdSelecionado,
            ComponenteData: this.informacao,
            Id: this.$route.params.id,
          }
        })
          .then(() => {
            // this.getComponetesByOrcamentoId()
            this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/caracteristicas-produto-ra`)
          }).finally(this.$refs.botaoContinuar.isBusy)
    },

    cancelandoadicionarcomponente(){ //cancelará e só fechará o popup mesmo
      this.popupadicionarcomponente=false
    },

    excluir(data){
      this.postExcluirOrcamentoComponente(data.Id)
      this.removerDoGrid(data.Id ,'Id')
    },
    removerDoGrid(id,campo){
      this.informacao = this.informacao.filter((obj)=> {
        return !(obj[campo] === id)
      })
  },

  postExcluirOrcamentoComponente(id){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/ExcluirOrcamentoComponente`,
        data:{
          Id:id
        }
      })
    },

    excluirComponente(id){
       this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/ExcluirOrcamentoComponente`,
        data:{
          Id:id
        }
      })
    },
    verificaMedidaPreenchida(medida){
      return (medida || medida === '0,00' || medida === '0.00')
    },
    GetProdutoByTableSistema(){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
          ProdutoController.GetProdutoByTableSistema().requisicao
          .then((resp) => {
            this.ProdutoSistemaOpcoes = resp.data.data;
          })
      }, 1000);
    },

    limpaProduto() {
      this.ProdutoSistemaId = null;
    },
    limpaSistema(){
      this.SistemaId = null;
    },
    limpaCamposSistema(){

      if (this.SistemaSelecionado == 0){
        this.ProdutoSistemaId = null;
        return
      }
      if (this.SistemaSelecionado == 2){
        this.SistemaId = null;
        return
      } 
      
      if (this.SistemaSelecionado != 2 || this.SistemaSelecionado != 0 ) {
        this.ProdutoSistemaId = null;
        this.SistemaId = null
      }
    },
   },

  computed: {

    componenteIndex(){
      let retorno = this.index;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.index++;
      return retorno;
    },

    ObrigatoriedadeConforme(){
      const conformeObrigatorio =
           !this.verificaMedidaPreenchida(this.novoComponente.NumeroAltura)
        && !this.verificaMedidaPreenchida(this.novoComponente.NumeroLargura)
        && !this.verificaMedidaPreenchida(this.novoComponente.NumeroComprimento)
        && !this.verificaMedidaPreenchida(this.novoComponente.NumeroAlturaTampa)
      return conformeObrigatorio;
    },

    ObrigatoriedadeCampos(){
      if(this.novoComponente.DescricaoMedidas === 0) return false;
      return !this.novoComponente.DescricaoMedidas;
    },

    ObrigatoriedadeGramaturaCapaExternaComp(){
      return this.novoComponente.DescricaoMaterial == 2 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7
    },
    ObrigatoriedadeDescricaoCapaExternaComp(){
      return this.novoComponente.DescricaoMaterial == 2 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    },
    ObrigatoriedadeAlturaTampaComp(){
      if(!this.ObrigatoriedadeCampos) return true;
      return (this.novoComponente.ComponenteTipo == 0 || this.novoComponente.ComponenteTipo == 3 || this.novoComponente.ComponenteTipo == 4 || this.novoComponente.ComponenteTipo == 5)
    },
    ObrigatoriedadePapelDeOndaComp(){
      return this.novoComponente.DescricaoMaterial == 1 || this.novoComponente.DescricaoMaterial == 3 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    },
    ObrigatoriedadeCapaInternaComp(){
      return this.novoComponente.DescricaoMaterial == 1 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    }
  },

});